import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { Url, USER_PROFILE_POSTS_SUB_PATHS, USER_PROFILE_SHOP_SUB_PATHS, USER_PROFILE_SECTION_PATHS, } from '@wix/da-url';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '../../../types/resource';
import s from './BasicUserLink.scss';
function getLinkUrl(_a, linkTo) {
    var username = _a.username;
    switch (linkTo) {
        case 'gallery':
            return Url.userGalleryLink({ username: username, gallectionType: 'gallery' });
        case 'favourites':
            return Url.userGalleryLink({ username: username, gallectionType: 'collection' });
        case 'posts':
            return Url.userPostsLink({
                username: username,
                subPath: USER_PROFILE_POSTS_SUB_PATHS.ALL,
            });
        case 'shop':
            return Url.userShopPath(username, USER_PROFILE_SHOP_SUB_PATHS.ALL);
        case 'about':
            return Url.userLink(username, USER_PROFILE_SECTION_PATHS.ABOUT);
        case 'home':
        default:
            return Url.userLink(username);
    }
}
export var BasicUserLink = function (_a) {
    var user = _a.user, _b = _a.user, type = _b.type, usericon = _b.usericon, username = _b.username, userId = _b.userId, useridUuid = _b.useridUuid, linkTo = _a.linkTo, children = _a.children, className = _a.className, biData = _a.biData, ariaHidden = _a["aria-hidden"], dataHook = _a["data-hook"], tabIndex = _a.tabIndex, onTouchEnd = _a.onTouchEnd;
    var userType = type === 'super group' ? 'super' : type;
    // TODO: use isGroup util function
    var biEventData = BiData(__assign(__assign({ itemid: user.userId, typeid: user.type.includes('group')
            ? ResourceType.GROUP
            : ResourceType.USER }, biData), { evid: 101, sectionname: BiContextProvidedValue }));
    return (React.createElement(BiLink, { biData: biEventData, "data-hook": dataHook ? dataHook : BiDataHook.USER_LINK, "data-username": username, "data-icon": usericon, "data-usertype": type, "data-userid": userId, "data-useruuid": useridUuid, href: getLinkUrl(user, linkTo), className: classnames('user-link', s['user-link'], s["link-".concat(userType)], className), "aria-hidden": ariaHidden, onTouchEnd: onTouchEnd, tabIndex: tabIndex }, children));
};
BasicUserLink.displayName = 'BasicUserLink';
export default BasicUserLink;
//# sourceMappingURL=BasicUserLink.js.map